import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { selectRateById } from "src/store/callrecorder/ratesSlice";
import { selectProviderEntities } from "src/store/callrecorder/providersSlice";
import { fetchRate } from "src/actions/callrecorder/ratesActions";
import { fetchProviders } from "src/actions/callrecorder/providersActions";

import PageLayout from "../_partials/PageLayout";
import SummaryShow from "src/componets/SummaryShow";
import Tabs from "src/componets/Tabs";
import SidebarShow from "./_partials/_SidebarShow";
import RateHistories from "./_partials/_RateHistories";
import Icon from "src/componets/Icon";

const Show: React.FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const record = useAppSelector(state => id ? selectRateById(state, id) : undefined);
  const providerEntities = useAppSelector(selectProviderEntities);

  useEffect(() => {
    if (id) {
      dispatch(fetchRate(id));
    }
    dispatch(fetchProviders({}));
  }, [id, dispatch]);

  const filterParams = useMemo(() => ({ rate_id: id }), [id]);

  const provider = record ? providerEntities[record.provider_id] : undefined;
  const title = record
    ? `${record.prefix}${record.iso ? ` (${record.iso})` : ''}${provider ? ` — ${provider.name}` : ''}`
    : '';

  return (
    <PageLayout className='v-rates-show'>
      <div className='v-container-fluid'>
        <div className='o-header'>
          {
            record &&
              <SummaryShow
                icon={<Icon icon="fa-solid fa-file-invoice-dollar" />}
                title={title}
                createdAt={record.created_at}
                updatedAt={record.updated_at}
                className='v-mb-15'
              />
          }
        </div>

        <Tabs
          paramsKey='tab'
          defaultActiveKey='history'
          destroyInactiveTabPane={true}
          items={[
            { label: 'History', key: 'history', children: <RateHistories filterParams={filterParams} /> },
          ]}
        />
      </div>

      <SidebarShow record={record} />
    </PageLayout>
  )
}

export default Show;
